import styled from '@emotion/styled';
import * as React from 'react';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      svg: React.SVGProps<SVGSVGElement>;
      path: React.SVGProps<SVGPathElement>;
      defs: React.SVGProps<SVGDefsElement>;
      linearGradient: React.SVGProps<SVGLinearGradientElement>;
      stop: React.SVGProps<SVGStopElement>;
    }
  }
}

const ChatBotIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <rect width={32} height={32} fill="#916FEF" rx={16} />
    <path
      fill="#fff"
      d="M22.667 13.917V12.25c0-.916-.75-1.666-1.667-1.666h-2.5c0-1.384-1.117-2.5-2.5-2.5a2.497 2.497 0 0 0-2.5 2.5H11c-.917 0-1.667.75-1.667 1.666v1.667a2.497 2.497 0 0 0-2.5 2.5c0 1.383 1.117 2.5 2.5 2.5v3.333c0 .917.75 1.667 1.667 1.667h10c.917 0 1.667-.75 1.667-1.667v-3.333c1.383 0 2.5-1.117 2.5-2.5 0-1.384-1.117-2.5-2.5-2.5ZM21 22.25H11v-10h10v10Zm-7.5-5c-.692 0-1.25-.558-1.25-1.25 0-.691.558-1.25 1.25-1.25s1.25.559 1.25 1.25c0 .692-.558 1.25-1.25 1.25ZM19.75 16c0 .692-.558 1.25-1.25 1.25s-1.25-.558-1.25-1.25c0-.691.558-1.25 1.25-1.25s1.25.559 1.25 1.25Zm-7.083 2.917h6.666v1.666h-6.666v-1.666Z"
    />
  </svg>
);

const BotIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  background-color: white;
  border-radius: 0.5rem;
`;

export const NewChatBotIcon = () => (
  <BotIconContainer>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.81151 0.75V4.86911M0.75 2.80956H4.87302M17.1885 15.0831V19.25M15.127 17.1666H19.25M8.78582 3.41781L7.4406 7.44579L3.40494 8.78845C2.23837 9.17657 2.23837 10.8235 3.40494 11.2116L7.4406 12.5543L8.78582 16.5823C9.17467 17.7466 10.8248 17.7466 11.2136 16.5823L12.5588 12.5543L16.5945 11.2116C17.7611 10.8235 17.7611 9.17657 16.5945 8.78845L12.5588 7.44579L11.2136 3.41781C10.8248 2.25346 9.17467 2.25346 8.78582 3.41781Z"
        stroke="url(#paint0_linear_15024_1900)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_15024_1900"
          x1="1.82558"
          y1="-4.8"
          x2="25.1477"
          y2="4.56914"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#009684" />
          <stop offset="0.514542" stopColor="#0D4AC3" />
          <stop offset="1" stopColor="#5435AB" />
        </linearGradient>
      </defs>
    </svg>
  </BotIconContainer>
);
export default ChatBotIcon;
